import React, { useState } from 'react'
import Button from 'components/controls/button'
import history from 'routes/history'
import TranslationsModal from 'containers/dashboard/translations-modal'
import AddTranslationsButton from 'components/add-translations'
import TranslationErrorModal from 'containers/dashboard/translation-error-modal'
import { sortAlphabetically, addTranslationsLabel, addTopicNameTranslationsLabel } from 'shared/helpers/functional'
import { Spinner } from '@blueprintjs/core'

import 'less/topic-name-translations.less'


const TopicNameTranslations = props => {
    const [editedTopicName, setEditedTopicName] = useState(props.currentProject.editedTopicNameDetails)
    const topicNameTranslations = props.currentProject.topicNameTranslations ? [...props.currentProject.topicNameTranslations.values()] : []
    const topicNameTranslationsSorted = sortAlphabetically(topicNameTranslations)
    const [languageTodelete, setLanguageTodelete] = useState('')
    const [topicNameIsRequired, setTopicNameIsRequired] = useState(new Map())


    const setTopicNameTranslations = (langCounty, value) => {
        setEditedTopicName(new Map(editedTopicName.set(langCounty, value)))
    }

    function handleCancel() {
        props.clearTranslations({ flag: 'topicName' })
        history.push(`/projects/${props.currentProject.id}/dashboard`)
    }

    function handleCancelSubmit(editedTopicName) {
        props.toggleTopicTransltionsErrorModal({ editedTopicName })
    }


    function handleSave() {
        let blockSave = false
        let label = ''
        let topicNameRequiredError = false
        let showRequiredError=false

        editedTopicName.forEach((value, key) => {
            if (value.length === 0) {
                topicNameRequiredError = true
                showRequiredError=true
            } else {
                topicNameRequiredError = false
            }

            if (value.length > 100) {
                blockSave = true
                label = label + addTopicNameTranslationsLabel(props.currentProject.languageAndLocalizationMap, props.currentProject.defaultLocalizationMap, key) + ', '
            }
            setTopicNameIsRequired(new Map(topicNameIsRequired.set(key, topicNameRequiredError)))

        })
        topicNameTranslations.forEach((value) => {
            if (!editedTopicName.has(value.langCode_countryCode)) {
                topicNameRequiredError = true
                showRequiredError = true
                setTopicNameIsRequired(new Map(topicNameIsRequired.set(value.langCode_countryCode, topicNameRequiredError)))
            }
        })
        if (showRequiredError === false) {
            blockSave && props.showSnackbarMessageError(`Topic Name for ${label} must be less than 100 characters`)
            blockSave && props.hideSnackbarMessage()
            !blockSave && props.addTopicNameTranslations({ 'editedTopicName': editedTopicName, 'id': props.currentProject.id, 'userId': props.currentProject.userId })
        }
    }

    function handleCancelTranslationModal() {
        props.toggleTranslationsModal(props.currentProject.editedConferenceLink, props.currentProject.editedMeetingInformationMap, editedTopicName)
    }

    let label = ''
    const addPlaceHolder = ( key, value) => {
        props.currentProject.defaultLocalizationMap.get(key) ?
            label = value.language_name + "-" + value.country
            :
            label = value.language_name
        return label
    }
    const showDeleteBtn = (langCode_countryCode) => {
        setLanguageTodelete(langCode_countryCode)
    }
    const deleteTopicTransltion = (langCode_countryCode) => {
         props.deleteTopicTransltion({
            translationsToDelete: langCode_countryCode,
            editedTopicName: editedTopicName,
            projectId: props.currentProject.id
        })
    }
    return (
        <div>
            <div className="new-topic-name">
                <div className="topic-name">
                    <div>
                        <h3> {props.t('edit.topic.name.sub.header')}</h3>
                        <div className='topic-name-message'>
                            {props.t('edit.topic.name.message')}
                        </div>
                        <hr />
                    </div>
                    <div className="bp3-form-group showable-box">
                        <div className="showable-box-content-container">
                            <div className="side-icon">
                                <i className="im-bubble-lines" />
                            </div>
                            <div className="showable-box-content">
                                <div className="header">{props.t('topic.name.title')}</div>
                                <div className="add-topic-name-body">
                                    <div className="add-topic-name-text">
                                        <span>{props.t('edit.topic.name.message.2')}</span>
                                    </div>
                                    <hr />
                                </div>
                                {(editedTopicName && topicNameTranslations && topicNameTranslations.length > 0) ?
                                    topicNameTranslationsSorted.map((item, i) => (
                                        <div key={item.id}>
                                            {item.langCode_countryCode === 'en_us' ?
                                                <div className='topic-name-title'>
                                                    <span> {props.t('topic.name.title')} </span>
                                                    <span className='italic'>{props.t('english.topic.name.message')}</span> </div>
                                                :
                                                <div className='topic-name-tranlsations-container'>
                                                    <div className="topic-name-translations" >
                                                        <i className="im-translations" />
                                                        <p className='translations-label'>  {addTranslationsLabel(props.currentProject.defaultLocalizationMap, item.langCode_countryCode, item)} Translations </p>
        
                                                    </div>
                                                    <div className='topic-name-header'>
                                                        <p className='topic-name-title'> {props.t('topic.name.title')}: {addTranslationsLabel(props.currentProject.defaultLocalizationMap, item.langCode_countryCode, item)} </p>
                                                        {item.langCode_countryCode !== 'en_us' && <p className="trash-logo-container">
                                                            <button className={'im-trash'} onClick={() => showDeleteBtn(item.langCode_countryCode)} />
                                                            {item.langCode_countryCode == languageTodelete &&
                                                                <button id={`del-${item.langCode_countryCode}`}
                                                                    className="remove-language-btn" onClick={() => deleteTopicTransltion(item.langCode_countryCode)}>Delete Topic Translation</button>}
                                                        </p>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            <div className={`topic-name-input-wrapper ${props.currentProject.canNotBeEdited.get(item.langCode_countryCode) ? 'disabled' : ''  }`}>
                                                <input className={`topic-name-input ${props.currentProject.canNotBeEdited.get(item.langCode_countryCode) ? 'disabled' : ''  } ${editedTopicName.get(item.langCode_countryCode) ? '' : 'italic'}`}
                                                    type="text"
                                                    name="topic-name"
                                                    placeholder={editedTopicName.get(item.langCode_countryCode) ? editedTopicName.get(item.langCode_countryCode) : `Enter ${addPlaceHolder(item.langCode_countryCode, item)} Translation`}
                                                    value={editedTopicName.get(item.langCode_countryCode)}
                                                    onChange={e => {
                                                        if (topicNameIsRequired.get(item.langCode_countryCode) === true) {
                                                            let topicNameMap=new Map() ;
                                                            topicNameMap.set(item.langCode_countryCode, false)
                                                            setTopicNameIsRequired(topicNameMap)
                                                        }
                                                        setTopicNameTranslations(item.langCode_countryCode, e.target.value)
                                                    }
                                                    }
                                                />
                                            </div>
                                            {topicNameIsRequired.get(item.langCode_countryCode) === true && <div className='error-message'> {props.t('topic.name.translation.required')} </div>}
                                            <hr className='hr-topic-name' />
                                        </div>
                                    )
                                    )
                                    : <Spinner intent="primary" />
                                }
                            
                                <AddTranslationsButton
                                    currentProject={props.currentProject}
                                    toggleTranslationsModal={props.toggleTranslationsModal}
                                    t={props.t}
                                    editedTopicName={editedTopicName}
                                    editedMeetingInformation={props.currentProject.editedMeetingInformationMap}
                                    editedConferenceLink={props.currentProject.conferenceLink}
                                    languages={props.currentProject.topicNamelanguages}
                                ></AddTranslationsButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="action-buttons">
                <Button
                    disabled={false}
                    className="cancel-button btn-primary"
                    type="submit"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    disabled={false}
                    className="save-button btn-primary"
                    type="submit"
                    isLoading={props.currentProject.isSubmittingTopicName}
                    onClick={handleSave}
                >
                    {props.t('save.changes')}
                </Button>
            </div>

            <TranslationsModal
                isOpen={props.currentProject.istranslationModalOpen}
                onCancel={handleCancelTranslationModal}
                onSubmit={props.addTranslations}
                t={props.t}
                getLanguageAndLocalizationData={props.getLanguageAndLocalizationData}
                currentProject={props.currentProject}
                languages={props.currentProject.topicNamelanguages}
                localizationMap={props.currentProject.topicNamelocalizationMap}
                flag={'topicName'}
                editedTopicName={editedTopicName}
                editedMeetingInformationMap={props.currentProject.editedMeetingInformationMap}
            ></TranslationsModal>
             <TranslationErrorModal
                isOpen={props.currentProject.toggleTopicTransltionsModal}
                onCancel={React.useCallback(() =>handleCancelSubmit(editedTopicName))}
                onSubmit={React.useCallback(() =>handleCancelSubmit(editedTopicName))}

                t={props.t}
            ></TranslationErrorModal>

        </div >
    )
}

export default TopicNameTranslations
